import { DataServiceOperator } from './data-service-operator.interface';

export class DataServiceMultiply implements DataServiceOperator {
	public calculate(valueA: number | string, valueB: number | string, defaultValue: number): number {
		if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
			return Number(valueA) * Number(valueB);
		}
		return defaultValue;
	}
}
